import {SvgIcon, useTheme} from '@mui/material';

export default function NameIcon() {
	const theme = useTheme();
	return (
		<SvgIcon width="16" height="16" viewBox="0 0 16 16">
			<path opacity="0.4"
			      d="M14.0533 5.72006V10.28C14.0533 11.0267 13.6533 11.7201 13.0066 12.1001L9.04661 14.3867C8.39994 14.7601 7.59994 14.7601 6.94661 14.3867L2.98661 12.1001C2.33994 11.7267 1.93994 11.0334 1.93994 10.28V5.72006C1.93994 4.9734 2.33994 4.28004 2.98661 3.90004L6.94661 1.61337C7.59327 1.24004 8.39327 1.24004 9.04661 1.61337L13.0066 3.90004C13.6533 4.28004 14.0533 4.96673 14.0533 5.72006Z"
			      fill={theme.palette.grey[600]}/>
			<path
				d="M8.00011 7.99996C8.85799 7.99996 9.55344 7.3045 9.55344 6.44661C9.55344 5.58873 8.85799 4.89331 8.00011 4.89331C7.14223 4.89331 6.44678 5.58873 6.44678 6.44661C6.44678 7.3045 7.14223 7.99996 8.00011 7.99996Z"
				fill={theme.palette.grey[600]}/>
			<path
				d="M9.78661 11.1066C10.3266 11.1066 10.6399 10.5067 10.3399 10.06C9.88661 9.38668 9.00661 8.93335 7.99995 8.93335C6.99328 8.93335 6.11328 9.38668 5.65995 10.06C5.35995 10.5067 5.67328 11.1066 6.21328 11.1066H9.78661Z"
				fill={theme.palette.grey[600]}/>
		</SvgIcon>
	);
}
